<script setup lang="ts">
import { useConfirm, VIcons } from '@/shared/ui'
import type { PropType } from 'vue'
import type { AdminMetersDataType } from '@/entities/Cabinet'
import { useTranslate } from '@/shared/lib'
import { useRoute } from 'vue-router'
import { useCabinetMetersDelete } from '@/features/Cabinet/AdminMeters/model/api'

const props = defineProps({
  item: {
    type: Object as PropType<AdminMetersDataType>,
    required: true,
  },
})

const { show } = useConfirm()
const { trs } = useTranslate()
const route = useRoute()

const { remove } = useCabinetMetersDelete(route.params.object_id as string)

/**
 * Обработка удаления конфигурации
 */
const clickHandler = () => {
  show({
    confirmFunc: async () => {
      await remove(props.item.id)
    },
    title: trs('itf.meter_remove'),
  })
}
</script>

<template>
  <VTooltip location="top" :open-delay="500" :text="$t('itf.delete')">
    <template #activator="{ props: tooltipProps }">
      <VBtn icon density="compact" color="error" v-bind="tooltipProps" @click="clickHandler">
        <VIcons type="delete" />
      </VBtn>
    </template>
  </VTooltip>
</template>
